import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Card, Flex, Group, NumberFormatter, Text } from '@mantine/core';
import Link from 'next/link';
export const ProfileRewards: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Card bg="var(--navbar-bg-color)" radius={5} p={{
    base: 10,
    sm: 20
  }}>
      <Group justify="space-between">
        <Text fz={{
        base: 12,
        sm: 13
      }} fw={700} tt="uppercase" c="var(--text-prime)">
          {i18n._('Referrals code')}
        </Text>
        <Text component={Link} href="#" fz={{
        base: 10,
        sm: 11
      }} fw={700} tt="uppercase" c="prime.12">
          {i18n._('view more')}
        </Text>
      </Group>

      <Flex mt={22} gap={20} justify={{
      base: 'space-between',
      md: 'start'
    }}>
        <Group gap={8} align="center">
          <Text fz={{
          base: 14,
          sm: 18
        }} fw={700} className={gunterzBold.className}>
            <NumberFormatter value={1} suffix="%" />
          </Text>
          <Text c="var(--text-dark)" fz={12} fw={700} tt="uppercase">
            {i18n._('Rakeback')}
          </Text>
        </Group>
        <Group gap={8} align="center">
          <Text fz={{
          base: 14,
          sm: 18
        }} fw={700} className={gunterzBold.className}>
            <NumberFormatter value={5} suffix="%" />
          </Text>
          <Text c="var(--text-dark)" fz={12} fw={700} tt="uppercase">
            {i18n._('XP BOOST')}
          </Text>
        </Group>
        <Group gap={8} align="center">
          <Text fz={{
          base: 14,
          sm: 18
        }} fw={700} className={gunterzBold.className}>
            <NumberFormatter value={1.2} decimalScale={1} />
          </Text>
          <Text c="var(--text-dark)" fz={12} fw={700} tt="uppercase">
            {i18n._('MULTIPLIER')}
          </Text>
        </Group>
      </Flex>
    </Card>;
};